import { Helmet } from "react-helmet-async";
import { ResellerDashboard } from "@/components/reseller/reseller-dashboard";
import PageTitle from "@/components/ui/page-title";

const ResellerDashboardPage = () => {
  return (
    <>
      <Helmet>
        <title>Dashboard Reseller - MoovaTV</title>
        <meta name="description" content="Dashboard para revendedores MoovaTV. Gerencie clientes, códigos de ativação e acompanhe suas vendas." />
        <meta name="keywords" content="reseller, dashboard, MoovaTV, revendedor" />
      </Helmet>

      <div className="container mx-auto py-6">
        <PageTitle className="mb-8">Dashboard Reseller do</PageTitle>
        <ResellerDashboard />
      </div>
    </>
  );
};

export default ResellerDashboardPage;
